/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  MobileAutocompleteInput component
 */

import { SharedMobileAutocompleteInputContainer } from '@zcode/nr/es/shared/components/Autocomplete/MobileAutocompleteInput'
import React from 'react'
import type { GetProps } from 'react-redux'

export const MobileAutocompleteInput = (
  props: Omit<GetProps<typeof SharedMobileAutocompleteInputContainer>, 'theme'>
) => {
  return <SharedMobileAutocompleteInputContainer {...props} />
}

export default MobileAutocompleteInput
